@if (nextFixtures.length) {
    <ms-gh-next-races [nextFixtures]="nextFixtures" />
}
@if (!nextFixtures.length) {
    <ms-error [links]="false" [message]="sitecore.horseRacing.tournaments.ErrNoTodayRaces" [severity]="'info'" />
}
